

export class SubCatgeoryJsonData {


    private accessoriesMappingChairsExaminationTretamentDentistry: any = [
        {
            beNumber: "-1-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-4",
            beCode: "DE-019",
            beCategory: "Micromotor",
            generalName: "Micromotor",
            workGroup: "Dental",
            purchaseCost: "3900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-1",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-2",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-4",
            beCode: "12-352",
            beCategory: "Lights,Dental,Intraoral",
            generalName: "Light Cure Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-5",
            beCode: "12-351",
            beCategory: "Lights,Dental",
            generalName: "Dental Examination Light",
            workGroup: "Dental",
            purchaseCost: "1500",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-6",
            beCode: "10-212",
            beCategory: "Aspirators,Dental",
            generalName: "Suction Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-7",
            beCode: "10-972",
            beCategory: "Compressors, Medical Air",
            generalName: "Air Compressor",
            workGroup: "Dental",
            purchaseCost: "12900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-9",
            beCode: "14-498",
            beCategory: "View Boxes,X-Ray",
            generalName: "X-Ray View Box",
            workGroup: "Dental",
            purchaseCost: "2263",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-10",
            beCode: "DE-050",
            beCategory: "Doctor Stool",
            generalName: "Doctor Stool",
            workGroup: "Dental",
            purchaseCost: "0",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-11",
            beCode: "DE-051",
            beCategory: "Assistant Stool",
            generalName: "Assistant Stool",
            workGroup: "Dental",
            purchaseCost: "0",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        }

    ]

    private accessoriesMappingChairsExaminationTretamentDentistrySpecialist: any = [
        {
            beNumber: "-1-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-4",
            beCode: "DE-019",
            beCategory: "Micromotor",
            generalName: "Micromotor",
            workGroup: "Dental",
            purchaseCost: "3900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-1",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-2",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-4",
            beCode: "12-352",
            beCategory: "Lights,Dental,Intraoral",
            generalName: "Light Cure Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-5",
            beCode: "12-351",
            beCategory: "Lights,Dental",
            generalName: "Dental Examination Light",
            workGroup: "Dental",
            purchaseCost: "1500",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-6",
            beCode: "10-212",
            beCategory: "Aspirators,Dental",
            generalName: "Suction Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-7",
            beCode: "10-972",
            beCategory: "Compressors, Medical Air",
            generalName: "Air Compressor",
            workGroup: "Dental",
            purchaseCost: "12900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-8",
            beCode: "DE-015",
            beCategory: "Intraoral Camera Dental",
            generalName: "Intra Oral Camera",
            workGroup: "Dental",
            purchaseCost: "4000",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-9",
            beCode: "14-498",
            beCategory: "View Boxes,X-Ray",
            generalName: "X-Ray View Box",
            workGroup: "Dental",
            purchaseCost: "2263",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-10",
            beCode: "DE-050",
            beCategory: "Doctor Stool",
            generalName: "Doctor Stool",
            workGroup: "Dental",
            purchaseCost: "0",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-11",
            beCode: "DE-051",
            beCategory: "Assistant Stool",
            generalName: "Assistant Stool",
            workGroup: "Dental",
            purchaseCost: "0",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        }

    ]

    private accessoriesMappingDentalDeliveryUnits: any = [
        {
            beNumber: "-1-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-1-4",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-2-4",
            beCode: "DE-019",
            beCategory: "Micromotor",
            generalName: "Micromotor",
            workGroup: "Dental",
            purchaseCost: "3900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-1",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-3-2",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-4",
            beCode: "12-352",
            beCategory: "Lights,Dental,Intraoral",
            generalName: "Light Cure Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-5",
            beCode: "12-351",
            beCategory: "Lights,Dental",
            generalName: "Dental Examination Light",
            workGroup: "Dental",
            purchaseCost: "1500",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            beNumber: "-7",
            beCode: "10-972",
            beCategory: "Compressors, Medical Air",
            generalName: "Air Compressor",
            workGroup: "Dental",
            purchaseCost: "12900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        }

    ]
    private accessoriesMappingDentalDeliveryUnitsLE: any = [
        {
            leNumber: "-1-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-1-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-1-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-1-4",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-2-1",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-2-2",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-2-3",
            beCode: "11-161",
            beCategory: "Handpieces, Dental",
            generalName: "Dental Hand Piece",
            workGroup: "Dental",
            purchaseCost: "1890",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-2-4",
            beCode: "DE-019",
            beCategory: "Micromotor",
            generalName: "Micromotor",
            workGroup: "Dental",
            purchaseCost: "3900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-3-1",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-3-2",
            beCode: "17-497",
            beCategory: "Scalers, Dental, Ultrasonic",
            generalName: "Ultrasonic Scaler Machine",
            workGroup: "Dental",
            purchaseCost: "3300",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-4",
            beCode: "12-352",
            beCategory: "Lights,Dental,Intraoral",
            generalName: "Light Cure Unit",
            workGroup: "Dental",
            purchaseCost: "1800",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-5",
            beCode: "12-351",
            beCategory: "Lights,Dental",
            generalName: "Dental Examination Light",
            workGroup: "Dental",
            purchaseCost: "1500",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        },
        {
            leNumber: "-7",
            beCode: "10-972",
            beCategory: "Compressors, Medical Air",
            generalName: "Air Compressor",
            workGroup: "Dental",
            purchaseCost: "12900",
            beConditionalStatus: "",
            manufacturerId: "",
            beCodeAndManufacturerId: "",
            serialNumber: "",
            jkkpCertficateNumber: "",
            statutoryExpiryDate: "",
            availability: ""
        }

    ]

    getAccessoriesMappingChairsExaminationTretamentDentistry(){
        return this.accessoriesMappingChairsExaminationTretamentDentistry;
    }

    getAccessoriesMappingChairsExaminationTretamentDentistrySpecialist(){
        return this.accessoriesMappingChairsExaminationTretamentDentistrySpecialist;
    }

    getAccessoriesMappingDentalDeliveryUnits(){
        return this.accessoriesMappingDentalDeliveryUnits;
    }
    getAccessoriesMappingDentalDeliveryUnitsLE(){
        return this.accessoriesMappingDentalDeliveryUnitsLE;
    }

}